<script>
  import DashBoardCard from "./DashBoardCard.svelte";
  import MenuHeading from "./../../shared/MenuHeading.svelte";
  import Layout from "./../../Layout/Layout.svelte";
  import config from "../../stores/config.js";
  import { onMount } from "svelte";
  import { Circle } from "svelte-loading-spinners";
  import axios from "axios";

  let loading = true;
  let stats;

  onMount(() => {
    axios
      .get(`${$config.backendURL}/stats`)
      .then((res) => {
        stats = res.data;
        loading = false;
      })
      .catch((err) => {
        loading = false;
        console.log(err);
      });
  });
</script>

<svelte:head>
  <title>Reports — Fabi CC System</title>
</svelte:head>

<Layout>
  <MenuHeading title="Reports" description="Reports & Statistics" />

  {#if loading}
    <div class="h-52 w-full flex items-center justify-center">
      <Circle size="50" color="rgb(16, 185, 129)" unit="px" />
    </div>
  {:else}
    <div class="grid grid-cols-3 gap-4">
      <!--  -->
      <DashBoardCard
        value={stats.nOrdersND}
        valueOf="Open Orders"
        url="/orders"
        faClass="fa-exclamation-circle"
        urgent
      />
      <DashBoardCard
        value={stats.nOrdersNDWeek}
        valueOf="Open This Week"
        url="/orders"
        faClass="fa-exclamation-circle"
        urgent
      />
      <DashBoardCard
        value={stats.nOrdersNDMonth}
        valueOf="Open This Month"
        url="/orders"
        faClass="fa-exclamation-circle"
        urgent
      />
      <!--  -->
      <DashBoardCard
        value={stats.nOrdersD}
        valueOf="Closed Orders"
        url="/orders"
        faClass="fa-check-circle"
      />
      <DashBoardCard
        value={stats.nOrdersDWeek}
        valueOf="Closed This week"
        url="/orders"
        faClass="fa-check-circle"
      />
      <DashBoardCard
        value={stats.nOrdersDMonth}
        valueOf="Closed This Month"
        url="/orders"
        faClass="fa-check-circle"
      />
      <!--  -->
      <DashBoardCard
        value={stats.nSuppliers}
        valueOf="Suppliers"
        url="/suppliers"
        faClass="fa-truck"
      />
      <!--  -->
      <DashBoardCard
        value={stats.nItems}
        valueOf="Items In Stock"
        url="/products"
        faClass="fa-database"
      />
      <DashBoardCard
        value={`R${stats?.nItemsPrice[0]?.total?.toFixed(2) || 0}`}
        valueOf="Total Price Raw Items"
        url="/products"
        faClass="fa-database"
      />
      <!--  -->
      <DashBoardCard
        value={stats.nFStyle}
        valueOf="Finished Goods"
        url="/products"
        faClass="fa-check-circle"
      />
      <!--  -->
      <DashBoardCard
        value={stats.nCustomers}
        valueOf="Number of Customers"
        url="/users"
        faClass="fa-users"
      />
      <!--  -->
      <DashBoardCard
        value={stats.nCmts}
        valueOf="Number of Cmts"
        url="/users"
        faClass="fa-users"
      />
    </div>
  {/if}
</Layout>
